import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'ngx-swiper-wrapper';

import { TrendingScreenContainerComponent } from './components/trending-screen-container/trending-screen-container.component';
import { ScreenListingItemModule } from '../screen-listing-item/screen-listing-item.module';

@NgModule({
  declarations: [TrendingScreenContainerComponent],
  imports: [CommonModule, SwiperModule, ScreenListingItemModule],
  exports: [TrendingScreenContainerComponent],
})
export class TrendingScreensModule {}
